import FormErrors from './FormErrors';

class Form {
    constructor(data, options) {
        this.defaults = Object.assign({}, data);
        this.errors = new FormErrors();
        this.saving = false;
        this.hasFiles = false;
        this.options = Object.assign({
            stayDisabledAfterSuccessfulSave: false,
            save: null,
            onSaved: null,
            onError: null,
            onValidationError: null,
        }, options);
        this.reset();
    }

    reset(entity = null) {
        for (let field in this.defaults)
            this[field] = (entity && entity.hasOwnProperty(field)) ? entity[field] : this.defaults[field];

        this.errors.clear();
    }

    setFile(field, event) {
        let file = event.target.files && event.target.files[0];
        this[field] = file;
        this.hasFiles = true;
        event.target.value = null;
    }

    data() {
        let data = {};

        for (let field in this.defaults)
            data[field] = this[field];

        return data;
    }

    convertToFormData(data) {
        let formData = new FormData();

        for (let field in data) {
            let value = data[field];
            if (value instanceof File)
                formData.append(field, value, value.name);
            else
                formData.append(field, data[field] || '');
        }

        return formData;
    }

    dataForSave() {
        let data = this.data();
        if (this.hasFiles)
            return this.convertToFormData(data);
        return data;
    }

    async save(...params) {
        this.errors.clear();
        this.saving = true;

        try {
            let result = await this.options.save(this.dataForSave(), ...params);

            if (this.options.onSaved)
                await this.options.onSaved(result);

            if (!this.options.stayDisabledAfterSuccessfulSave)
                this.saving = false;
            return result;
        } catch (e) {
            if (e.response && e.response.status === 422) {
                e.isValidationError = true;
                this.errors.apply(e.response.data.errors);

                if (this.options.onValidationError)
                    await this.options.onValidationError(e);
            } else {
                if (this.options.onError)
                    await this.options.onError(e);
            }

            this.saving = false;
            throw e;
        }
    }
};

export default Form;
